<wl-invoice-selector-form #invoiceSelectorForm [searchParams]="searchParams" (searching)="handleSearching($event)"
  (accessDenied)="handleAccessDenied($event)" (result)="handleSearchResultReturned($event)"></wl-invoice-selector-form>

<div class="container-fluid marginalize" [hidden]="!hasSearched">
  <p-table [showGridlines]="true" #searchReultsGrid [lazy]="true" [rows]="10" [value]="searchResult.Result" [paginator]="true" (onLazyLoad)="lazyLoadSearchResults($event)" [totalRecords]="searchResult.TotalCount" sortField="ProfileReportName">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th [pSortableColumn]="'ProfileId'" style="width: 100px;">
          {{ 'revenue.invoice-selector.profile-id-column-header' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th [pSortableColumn]="'InvoiceNum'" style="width: 150px;">
          {{ 'revenue.invoice-selector.invoice-num-column-header' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th [pSortableColumn]="'ProfileReportName'">
          {{ 'revenue.invoice-selector.profile-report-name-column-header' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th [pSortableColumn]="'RevenueItemName'">
          {{ 'revenue.invoice-selector.revenue-item-column-header' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th [pSortableColumn]="'TotalAmount'" class="text-right" style="width: '150px;">
          {{ 'revenue.invoice-selector.total-amount-column-header' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
        <th [pSortableColumn]="'AmountDue'" class="text-right">
          {{ 'revenue.invoice-selector.amount-due-column-header' | translate | titlecase }}
          <p-sortIcon></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-invoice>
      <tr>
        <td>
          <div style="overflow: hidden;">{{ invoice.ProfileId }}</div>
        </td>
        <td>
          <div style="overflow: hidden;">{{ invoice.InvoiceNum }}</div>
        </td>
        <td>
          <a [routerLink]="['/profile/' + invoice.ProfileId]">
            <wl-profile-type-icon *ngIf="invoice && invoice.ProfileId" [isMember]="invoice.ProfileMember"
              [isOrg]="invoice.ProfileOrgInd" [profileId]="invoice.ProfileId"
              [memberTypeIconColor]="invoice.ProfileMemberTypeIconColor"></wl-profile-type-icon>
            {{ invoice.ProfileReportName }}
          </a>
        </td>
        <td>
          <div style="overflow:hidden">{{ invoice.RevenueItemName }}</div>
        </td>
        <td class="text-right">
          <div style="overflow:hidden">{{ invoice.TotalAmount | currency }}</div>
        </td>
        <td class="text-right">
          <div style="overflow:hidden">{{ invoice.AmountDue | currency }}</div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr>
        <td colspan="6">
          <wl-busy [show]="searching"></wl-busy>
          <div [hidden]="searching" class="pull-right">
            {{ searchResult.TotalCount }} {{ 'revenue.invoice-selector.invoices-label' | translate | titlecase }}
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
<p-progressSpinner *ngIf="searching"></p-progressSpinner>
</div>